const SELECTORS = {
  menu: '[data-js="apostas-menu"]',
  list: '.apostas-menu-list',
  toggle: '[data-js="apostas-menu-toggle"]',
  dropdown: '[data-js="apostas-menu-dropdown"]'
}

let openToggle = null
let openDropdown = null

const closeDropdown = () => {
  if (!openToggle || !openDropdown) return
  openToggle.setAttribute('aria-expanded', 'false')
  openDropdown.removeAttribute('data-open')
  openDropdown.setAttribute('hidden', '')
  openToggle = null
  openDropdown = null
}

const positionDropdown = (toggle, dropdown) => {
  const rect = toggle.getBoundingClientRect()
  const dropdownWidth = dropdown.offsetWidth
  const viewportWidth = window.innerWidth

  let left = rect.left
  if (left + dropdownWidth > viewportWidth - 8) {
    left = Math.max(8, viewportWidth - dropdownWidth - 8)
  }

  dropdown.style.top = `${rect.bottom}px`
  dropdown.style.left = `${left}px`
}

const openDropdownFor = (toggle, dropdown) => {
  if (openToggle === toggle) {
    closeDropdown()
    return
  }
  closeDropdown()

  toggle.setAttribute('aria-expanded', 'true')
  dropdown.removeAttribute('hidden')
  dropdown.setAttribute('data-open', 'true')
  positionDropdown(toggle, dropdown)

  openToggle = toggle
  openDropdown = dropdown
}

const markActiveItem = (menu) => {
  const currentPath = window.location.pathname.replace(/\/+$/, '') || '/'
  const links = menu.querySelectorAll('.apostas-menu-link[href], .apostas-menu-sublink[href]')

  let bestMatch = null
  let bestLength = 0

  links.forEach((link) => {
    try {
      const url = new URL(link.getAttribute('href'), window.location.origin)
      const linkPath = url.pathname.replace(/\/+$/, '') || '/'
      if (currentPath === linkPath || (linkPath !== '/' && currentPath.startsWith(`${linkPath}/`))) {
        if (linkPath.length > bestLength) {
          bestMatch = link
          bestLength = linkPath.length
        }
      }
    } catch (_) {
      // ignore non-URL hrefs
    }
  })

  if (!bestMatch) return

  bestMatch.classList.add('is-active')

  // Also highlight the top-level item that contains this match.
  const parentItem = bestMatch.closest('.apostas-menu-item')
  if (parentItem) {
    const topLink = parentItem.querySelector('.apostas-menu-link')
    if (topLink) topLink.classList.add('is-active')
  }
}

export const initApostasMenu = () => {
  const menu = document.querySelector(SELECTORS.menu)
  if (!menu) return

  const list = menu.querySelector(SELECTORS.list)

  menu.querySelectorAll(SELECTORS.toggle).forEach((toggle) => {
    const dropdown = toggle.parentElement.querySelector(SELECTORS.dropdown)
    if (!dropdown) return

    toggle.addEventListener('click', (event) => {
      event.preventDefault()
      event.stopPropagation()
      openDropdownFor(toggle, dropdown)
    })
  })

  document.addEventListener('click', (event) => {
    if (!openDropdown) return
    if (openDropdown.contains(event.target) || openToggle?.contains(event.target)) return
    closeDropdown()
  })

  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape') {
      closeDropdown()
      openToggle?.focus()
    }
  })

  const reposition = () => {
    if (openToggle && openDropdown) positionDropdown(openToggle, openDropdown)
  }

  window.addEventListener('resize', reposition)
  window.addEventListener('scroll', closeDropdown, { passive: true })
  list?.addEventListener('scroll', closeDropdown, { passive: true })

  markActiveItem(menu)
}
